import { ProductsData } from './types';

export const DEFAULT_FABRIC_TAB = 'easy-care-cotton';
export const DEFAULT_FABRIC_ID = '114';
export const DEFAULT_FABRIC = 'images/fabric/EasyCare Cotton/114.jpg';
export const DEFAULT_FABRIC_NAME = 'Bottle Red';
export const DEFAULT_FABRIC_PRICE = '$ 95';
export const DEFAULT_INNER_IMAGE = 'images/inner-fabric/RKS 188-07.jpg';
export const DEFAULT_INNER_VALUE = 'RKS-188-07';
export const DEFAULT_STITCH = '#dad4c5';
export const DEFAULT_STITCH_NAME = 'white';
export const DEFAULT_FABRIC_OBJ = {
    tab: DEFAULT_FABRIC_TAB,
    value: DEFAULT_FABRIC_ID,
    img: DEFAULT_FABRIC,
    name: DEFAULT_FABRIC_NAME,
    price: DEFAULT_FABRIC_PRICE,
};

export const INNER_FABRIC_AS_OUTER = {
    value: '',
    activePlacement: 'inner-collar',
    innerPlacement: {
        'inner-collar': {
            'placement-id': 'inner-collar',
            img: DEFAULT_FABRIC,
            isSameAsOuter: false,
            fabricId: DEFAULT_FABRIC_ID,
        },
        'inner-cuff': {
            'placement-id': 'inner-cuff',
            img: DEFAULT_FABRIC,
            isSameAsOuter: false,
            fabricId: DEFAULT_FABRIC_ID,
        },
        'inner-placket': {
            'placement-id': 'inner-placket',
            img: DEFAULT_FABRIC,
            isSameAsOuter: false,
            fabricId: DEFAULT_FABRIC_ID,
        },
        'elbow-patch': {
            'placement-id': 'elbow-patch',
            img: DEFAULT_FABRIC,
            isSameAsOuter: false,
            fabricId: DEFAULT_FABRIC_ID,
        },
    },
};

export const INIT_PRODUCT_DATA: ProductsData = {
    fabric: {
        tab: DEFAULT_FABRIC_TAB,
        value: DEFAULT_FABRIC_ID,
        img: DEFAULT_FABRIC,
        name: DEFAULT_FABRIC_NAME,
        price: DEFAULT_FABRIC_PRICE,
    },
    collar: {
        value: 'normal-collar',
    },
    cuff: {
        tab: 'long-sleeve',
        value: '1-button-square',
        elbowPatch: false,
    },
    'inner-fabric': {
        value: '',
        activePlacement: 'inner-collar',
        innerPlacement: {
            'inner-collar': {
                'placement-id': 'inner-collar',
                img: DEFAULT_INNER_IMAGE,
                isSameAsOuter: false,
                fabricId: DEFAULT_INNER_VALUE,
            },
            'inner-cuff': {
                'placement-id': 'inner-cuff',
                img: DEFAULT_INNER_IMAGE,
                isSameAsOuter: false,
                fabricId: DEFAULT_INNER_VALUE,
            },
            'inner-placket': {
                'placement-id': 'inner-placket',
                img: DEFAULT_INNER_IMAGE,
                isSameAsOuter: false,
                fabricId: DEFAULT_INNER_VALUE,
            },
            'elbow-patch': {
                'placement-id': 'elbow-patch',
                img: DEFAULT_INNER_IMAGE,
                isSameAsOuter: false,
                fabricId: DEFAULT_INNER_VALUE,
            },
        },
    },
    'back-pleats': {
        value: 'no-back-pleats',
    },
    pocket: {
        value: 'no-pocket',
    },
    placket: {
        value: 'no-placket',
    },
    monogram: {
        value: '',
        placements: {
            'back-of-collar': {
                'placement-id': 'back-of-collar',
                'style-id': 'Arial',
                isVisible: false,
                text: '',
                color: '#e1dfd7',
            },
            'left-breast-pocket': {
                'placement-id': 'left-breast-pocket',
                'style-id': 'Arial',
                isVisible: false,
                text: '',
                color: '#e1dfd7',
            },
            'left-stomach': {
                'placement-id': 'left-stomach',
                'style-id': 'Arial',
                isVisible: false,
                text: '',
                color: '#e1dfd7',
            },
            'left-shirt-tail': {
                'placement-id': 'left-shirt-tail',
                'style-id': 'Arial',
                isVisible: false,
                text: '',
                color: '#e1dfd7',
            },
            'right-center-cuff': {
                'placement-id': 'right-center-cuff',
                'style-id': 'Arial',
                isVisible: false,
                text: '',
                color: '#e1dfd7',
            },
            'left-center-cuff': {
                'placement-id': 'left-center-cuff',
                'style-id': 'Arial',
                isVisible: false,
                text: '',
                color: '#e1dfd7',
            },
        },
        activePlacement: '',
    },
    stitch: {
        value: 'white',
        color: '#dad4c5',
        theLastOne: false,
    },
};
